import { render, staticRenderFns } from "./fieldManyToOne.vue?vue&type=template&id=6b9df5a0&scoped=true&"
import script from "./fieldManyToOne.vue?vue&type=script&lang=js&"
export * from "./fieldManyToOne.vue?vue&type=script&lang=js&"
import style0 from "./fieldManyToOne.vue?vue&type=style&index=0&id=6b9df5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9df5a0",
  null
  
)

export default component.exports